import React, { FunctionComponent } from 'react';
import { StyleProp, StyleSheet, Text, TextStyle, View, ViewStyle } from 'react-native';
import Theme, { ThemeType } from '../../../theme';
import { themeStyleMapper } from './PersonaliseWorkoutSetup';

interface IProps {
  themeType: ThemeType;
  title: string;
  style?: StyleProp<TextStyle>;
}

export const SetupHeaderTitle: FunctionComponent<IProps> = ({ themeType = ThemeType.light, title, style }) => {
  const themeStyle = themeStyleMapper[themeType];
  return <Text style={[themeStyle.textColor1, styles.title, style]}>{title}</Text>;
};

const styles = StyleSheet.create({
  title: {
    fontSize: 22,
    fontFamily: Theme.Custom700,
  },
});
